import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || 'http://localhost:3000'
});

export function setAuthToken(token) {
  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
export function clearAuthToken() {
  delete api.defaults.headers.common['Authorization'];
}

// Interceptor de errores básico
api.interceptors.response.use(
  res => res,
  err => {
    if (err.response && err.response.data && err.response.data.error) {
      console.error('API error:', err.response.data.error);
    }
    return Promise.reject(err);
  }
);

export default api;
